var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled from 'styled-components';
var Span = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: ", ";\n  border-width: ", ";\n  border-style: ", ";\n  border-color: ", ";\n  color: ", ";\n  display: inline-block;\n  font-size: 0.9em;\n  font-weight: ", ";\n  left: ", ";\n  line-height: ", ";\n  padding: 0.25em 0.75em 0.35em 0.75em;\n  position: ", ";\n  text-align: center;\n  top: ", ";\n  vertical-align: baseline;\n  white-space: nowrap;\n\n  /* Empty badges collapse automatically */\n  &:empty {\n    display: none;\n  }\n\n  .btn .badge {\n    position: relative;\n    top: -1px;\n  }\n"], ["\n  background-color: ", ";\n  border-radius: ", ";\n  border-width: ", ";\n  border-style: ", ";\n  border-color: ", ";\n  color: ", ";\n  display: inline-block;\n  font-size: 0.9em;\n  font-weight: ", ";\n  left: ", ";\n  line-height: ", ";\n  padding: 0.25em 0.75em 0.35em 0.75em;\n  position: ", ";\n  text-align: center;\n  top: ", ";\n  vertical-align: baseline;\n  white-space: nowrap;\n\n  /* Empty badges collapse automatically */\n  &:empty {\n    display: none;\n  }\n\n  .btn .badge {\n    position: relative;\n    top: -1px;\n  }\n"])), function (p) {
  return p.theme[p.brand];
}, function (p) {
  return p.theme.borderRadiusBadge;
}, function (p) {
  return p.theme.themeName === 'greenlight' ? '1px' : undefined;
}, function (p) {
  return p.theme.themeName === 'greenlight' ? 'solid' : undefined;
}, function (p) {
  return p.theme.themeName === 'greenlight' ? p.theme.level3 : p.theme[p.brand];
}, function (p) {
  return p.theme.white;
}, function (p) {
  return p.theme.fontWeightBold;
}, function (p) {
  return p.attach ? '-1.33em' : undefined;
}, function (p) {
  return p.sidebar ? 2 : 1;
}, function (p) {
  return p.attach ? 'relative' : undefined;
}, function (p) {
  return p.attach ? '-0.66em' : undefined;
});

var Badge = function Badge(_a) {
  var attach = _a.attach,
      sidebar = _a.sidebar,
      children = _a.children,
      brand = _a.brand,
      props = __rest(_a, ["attach", "sidebar", "children", "brand"]);

  return React.createElement(Span, Object.assign({
    className: "badge" + (brand ? " badge-" + brand + (attach ? '-attached' : '') : ''),
    brand: brand,
    attach: attach,
    sidebar: sidebar
  }, props), children);
};

export default Badge;
var templateObject_1;